import React, { lazy, Suspense } from 'react';

const LazyAdminDealersPage = lazy(() => import('./AdminDealersPage'));

const AdminDealersPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAdminDealersPage {...props} />
  </Suspense>
);

export default AdminDealersPage;
